import { useMessageFeedback } from "../../hooks/useMessageFeedbacks";
import { useChatboxStore } from "../../store";
import {
  MessageFeedbackType,
  MessagingParticipantType,
  MessagingStatus,
  type MessagingMessage,
} from "@/model/messaging";
import { Button } from "@deputy-ai/ui/button/Button";
import { useCallback } from "react";
import {
  MdOutlineThumbDown,
  MdOutlineThumbUp,
  MdThumbDown,
  MdThumbUp,
} from "react-icons/md";

interface FeedbackProps {
  message: MessagingMessage;
}

export const Feedback = ({ message }: FeedbackProps) => {
  const {
    use: { options, lastMessage },
    bind: { sendMessageFeedback },
  } = useChatboxStore();

  const messageFeedback = useMessageFeedback(message);

  const handleFeedback = useCallback(
    async (feedback: MessageFeedbackType) => {
      await sendMessageFeedback({
        messageUid: message.uid,
        feedbackType: feedback,
      });
    },
    [message]
  );

  if (
    message.participant?.type !== MessagingParticipantType.AIAgent ||
    (message.uid !== lastMessage?.uid && messageFeedback === null) ||
    !options?.feedback?.enabled
  ) {
    return null;
  }

  if (
    message.status === MessagingStatus.Typing ||
    message.status === MessagingStatus.Failed ||
    message.status === MessagingStatus.Sending ||
    message.status === MessagingStatus.Pending
  ) {
    return null;
  }

  const ThumbUpIcon =
    messageFeedback === MessageFeedbackType.THUMB_UP
      ? MdThumbUp
      : MdOutlineThumbUp;
  const ThumbDownIcon =
    messageFeedback === MessageFeedbackType.THUMB_DOWN
      ? MdThumbDown
      : MdOutlineThumbDown;

  return (
    <div className="mt-2">
      <Button
        variant="ghost"
        size="xs"
        onClick={async () => await handleFeedback(MessageFeedbackType.THUMB_UP)}
        icon={
          <ThumbUpIcon className="text-gray-500 transition hover:text-blue-400" />
        }
      />
      <Button
        variant="ghost"
        size="xs"
        onClick={async () =>
          await handleFeedback(MessageFeedbackType.THUMB_DOWN)
        }
        icon={
          <ThumbDownIcon className="text-gray-500 transition hover:text-blue-400" />
        }
      />
    </div>
  );
};
